import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-impressum',
  imports: [],
  templateUrl: './impressum.html',
  styleUrl: './impressum.css',
})
export class Impressum implements OnInit {

  ngOnInit() {
    // Scroll to top when component loads, especially important for mobile devices
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
